import { V3Models } from "@istari/istari-client";

import { EditAccess } from "~/secure-connections/model/secure-connection";

type ReceivedAccessLevel =
  V3Models.SendingConnectionDto["receivedAccessLevel"] | V3Models.ReceivingConnectionDto["receivedAccessLevel"];

// Exhaustive over the SDK union so a new `ReceivedAccessLevel` variant surfaces
// as a compile error here instead of silently collapsing to "viewer".
export function toEditAccess(level: ReceivedAccessLevel): EditAccess {
  switch (level) {
    case "Editor":
      return "editor";
    case "Viewer":
      return "viewer";
  }
}

export function fromEditAccess(access: EditAccess): V3Models.ReceivedAccessLevel {
  switch (access) {
    case "editor":
      return "Editor";
    case "viewer":
      return "Viewer";
  }
}
